<nz-card style="margin-bottom: 10px;">
  <nz-spin [nzSpinning]="loading">
    <div class="query-condition-box margin-top-10 padding-bottom-10">
      <div>
        <form nz-form [formGroup]="validateForm">
          <div class="条件区">
            <!-- 第一行 -->
            <div nz-row>
              <div nz-col nzSpan="2" *ngIf="ShowSite">

                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "Site" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="20">
                    <nz-select formControlName="Site" (ngModelChange)="valuehandleChange()" nzAllowClear
                      nzPlaceHolder="{{'ALL'|translate}}">
                      <nz-option *ngFor="let option of SiteList" [nzLabel]="option.siteName" [nzValue]="option.site">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="4" *ngIf="ShowBuyer">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "Buyer" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nz-col nzSpan="22">
                    <nz-select [nzServerSearch]="true" nzMode="multiple" formControlName="Buyer"
                      (nzOnSearch)="userSearch($event)" style="border-radius:6px;"
                      nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true" [nzShowSearch]="true"
                      (ngModelChange)="valuehandleChange()">
                      <nz-option *ngFor="let o of userOptionList" [nzValue]="o.userId"
                        nzLabel="{{o.userId}}/{{o.englishName}}" nzCustomContent>
                        <span>{{o.userId}}/{{o.englishName}}</span>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="8" *ngIf="ShowVendor">

                <nz-form-label *ngIf="UserRequestlimits">
                  <div class="width-100-percent label-font">
                    {{ "VendorName" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item *ngIf="UserRequestlimits">
                  <nz-form-control nzSpan="20">

                    <nz-select [nzServerSearch]="true" nzMode="multiple" formControlName="Vendor"
                      (nzOnSearch)="VendorSearch($event)" style="border-radius:6px;" nzPlaceHolder="{{'ALL'|translate}}"
                      [nzAllowClear]="true" [nzShowSearch]="true" (ngModelChange)="valuehandleChange()">
                      <nz-option *ngFor="let o of VendorOptionList" [nzValue]="o.vendorCode" nzLabel="{{o.vendorName}}"
                        nzCustomContent>
                        <span>{{o.vendorName}}</span>
                      </nz-option>
                    </nz-select>

                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <!-- 第二行 -->
            <div nz-row class="row-with-spacing">
              <div nz-col nzSpan="4" *ngIf="ShowRNO">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "StatementNo" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <input nz-input formControlName="RNO" (ngModelChange)="valuehandleChange()" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="4" *ngIf="ShowPONO">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "table.PONO" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <input nz-input formControlName="PONO" (ngModelChange)="valuehandleChange()" />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="4" *ngIf="ShowPANo">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "PANo" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <input nz-input formControlName="PANo" (ngModelChange)="valuehandleChange()" />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="4" *ngIf="ShowAutopaNo">
                <nz-form-label nzSpan="8">
                  <div class="width-100-percent label-font">{{ "AutoPaNo" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="22">
                  <input nz-input formControlName="AutoPaNo" (ngModelChange)="valuehandleChange()" />
                </nz-form-control>
              </div>

              <div nz-col nzSpan="4" *ngIf="ShowTime">
                <nz-form-label>
                  <div class="width-100-percent label-font">{{ "RNOTime" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="22">
                  <nz-range-picker [nzFormat]="dateFormat" nzPlaceHolder='' formControlName="StatementMonth"
                    (ngModelChange)="valuehandleChange()"></nz-range-picker>
                </nz-form-control>
              </div>
              <div nz-col nzSpan="4" *ngIf="ShowBillingStatus">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "BillingStatus" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <nz-select formControlName="BillingStatus" nzAllowClear (ngModelChange)="valuehandleChange()">
                      <nz-option nzLabel="All" nzValue=""></nz-option>
                      <nz-option nzLabel="{{'PaymentApplication'|translate}}" nzValue="0"></nz-option>
                      <nz-option nzLabel="{{'ThePaymentApproved'|translate}}" nzValue="1"></nz-option>
                      <nz-option nzLabel="{{'PaymentToFinance'|translate}}" nzValue="2"></nz-option>
                      <nz-option nzLabel="{{'PaymentToFilled'|translate}}" nzValue="3"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col class="row-with-spacing-button">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeQuery()">
                  <span nz-icon nzType="search">
                  </span>
                  {{ "Query" | translate}}
                </button>
              </div>
              <div nz-col class="row-with-spacing-button">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeDownload()">
                  <span nz-icon nzType="export" nzTheme="outline"></span>
                  {{'Export'|translate}}
                </button>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </nz-spin>
</nz-card>
